import { HttpErrorResponse } from '@angular/common/http';
import { throwError } from 'rxjs';

class HttpError {
    public readonly message: string;
    public readonly status: number;
    public readonly trace?: string;

    constructor(props: { message: string; status: number; trace?: string }) {
        this.message = props.message;
        this.status = props.status;
        this.trace = props.trace;
    }
}

export function HandleAjaxError(httpErrorResponse: HttpErrorResponse) {
    let errorMessage = 'HTTP Error';
    const { error, message, status } = httpErrorResponse;

    if (typeof error?.message === 'string') {
        errorMessage = error?.message;
    } else if (typeof error?.innerError?.message === 'string') {
        errorMessage = error?.innerError?.message;
    } else if (typeof error?.error?.innerError?.message === 'string') {
        // graph
        errorMessage = error.error.innerError.message;
    } else if (typeof error === 'string') {
        errorMessage = error;
    } else if (typeof message === 'string') {
        errorMessage = message;
    }

    let trace: string = undefined;

    if (error?.trace) {
        trace = error.trace;
    }

    const httpError = new HttpError({
        ...httpErrorResponse,
        message: errorMessage,
        trace,
        status: status,
    });

    return throwError(() => httpError);
}
